export default function initSubWarehouseStocks() {
    return {
        async showModalSubWarehouseStock(event, id) {
            // event.preventDefault();
            const url = `/api/stocks/sub-warehouse/${id}/show-data-modal`;
            
            // Use the global ERPHelpers function for loading modal content
            await ERPHelpers.loadModalContent('addEditModal', url);
        },
    }
}
